import { useState } from 'react';
import RejectPresetModal from './RejectModal';
import { prepareSql } from '../../../utils';
import { Role } from '../../../features/authentication/types/auth.types';
import { ApprovalStatus } from '../../main/components/Preset/models';

const RejectButton = ({
  id,
  username,
  label,
  onReject,
  role,
}: {
  id: number;
  username: string;
  label: string;
  onReject: (reason: string) => void;
  role: Role;
}) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const handleSubmit = async (rejectionReason: string) => {
    closeModal();

    await rejectPreset(rejectionReason);

    await notifyReject();

    onReject(rejectionReason);
  };

  const rejectPreset = async (reason: string) => {
    try {
      await fetch(
        `https://prod-15.eastus.logic.azure.com:443/workflows/935c0d0a0c654359b40a954cc118770b/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=BzAcr3yCy2ijN2IrSloKghn27qZenIWePKTcWkyZwzA`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: id,
            newStatus: role === Role.CRO ? ApprovalStatus.REJECTED_CRO : ApprovalStatus.REJECTED_APPROVER,
            rejectionReason: prepareSql(reason),
          }),
        }
      );
    } catch (error) {
      console.error('Error rejecting preset:', error);
    }
  };

  const notifyReject = async () => {
    try {
      const response = await fetch(
        'https://prod-63.eastus.logic.azure.com:443/workflows/fb031a87ddcc4fee89a2a78a306662d9/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=sqmR4K3nazu8K5dwq5gj4dYQ9nVGJUp-BRMkurGx6w0',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: id,
            email: username,
            label: label,
            status: role === Role.CRO ? 'rejected export' : 'rejected discount',
          }),
        }
      );
    } catch (error) {
      console.error('Error notifying rejection:', error);
    }
  };

  return (
    <div>
      {modalIsOpen && <RejectPresetModal onRequestClose={closeModal} onSubmit={handleSubmit} />}
      <button onClick={openModal} style={buttonStyles}>
        Reject
      </button>
    </div>
  );
};

// Define styles for the button
const buttonStyles = {
  height: '5.6vh',
  width: '24vh',
  fontSize: '1.6vh',
  fontWeight: '700',
  color: '#ffffff',
  backgroundColor: 'rgba(243, 119, 102, 1)',
  border: 'none',
  borderRadius: '1.6vh',
  cursor: 'pointer',
  transition: 'background-color 0.3s, transform 0.2s',
  outline: 'none',
};

export default RejectButton;
